import { render } from "./IdBack.vue?vue&type=template&id=125cfbc8"
import script from "./IdBack.vue?vue&type=script&lang=js"
export * from "./IdBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__